// extracted by mini-css-extract-plugin
module.exports = {"cici_edit":"Edit_cici_edit__1Xhm2","cici_editText":"Edit_cici_editText__1SQ8V","cici_editImage":"Edit_cici_editImage__27jP8"};